import React, { forwardRef, useRef } from "react";
import { useAutoResizeTextarea } from "../../hooks/useAutoResizeTextarea";

type Props = {
    id?: string;
    value: string;
    onChange: (value: string) => void;
    onKeyDown?: (e: React.KeyboardEvent<HTMLTextAreaElement>) => void;
    onFocus?: () => void;
    onBlur?: () => void;
    placeholder?: string;
    className?: string;
};

export const ExpandingTextarea = forwardRef<HTMLTextAreaElement, Props>(
    ({ id, value, onChange, onKeyDown, onFocus, onBlur, placeholder, className }, ref) => {
        const innerRef = useRef<HTMLTextAreaElement | null>(null);
        const mergedRef = (node: HTMLTextAreaElement) => {
            innerRef.current = node;
            if (typeof ref === "function") ref(node);
            else if (ref && "current" in ref) (ref as any).current = node;
        };

        useAutoResizeTextarea(innerRef, [value]);

        return (
            <textarea
                id={id}
                ref={mergedRef}
                value={value}
                placeholder={placeholder}
                onChange={(e) => onChange(e.target.value)}
                onKeyDown={onKeyDown}
                onFocus={onFocus}
                onBlur={onBlur}
                rows={1}
                style={{ height: "auto" }}
                className={className ?? "expanding-textarea"}
                autoFocus
            />
        );
    }
);
ExpandingTextarea.displayName = "ExpandingTextarea";